var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"container"},[_c('span',{class:{checkmark:true,marked:_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }